export const GAAddToCart = (products, phrases) => {
  const itemVariant = products[1].options.size
    ? {
        item_variant: `${phrases.size} - ${products[1].options.size}`,
      }
    : {}
  const itemCategory2 = products[1].options.metal ? { item_category2: products[1].options.metal } : {}
  const itemCategory3 = products[1].options.metal_color ? { item_category3: products[1].options.metal_color } : {}
  const itemCategory4 = products[1].options.product_collection ? { item_category4: products[1].options.product_collection } : {}
  const dataLayer = window.dataLayer || []
  dataLayer.push({ ecommerce: null })
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      items: [
        {
          item_name: products[1].name,
          item_id: products[1].options.parent_product.sku,
          price: products[1].price,
          quantity: products[1].qty,
          item_brand: "Укрзолото",
          item_category: products[1].options.categories,
          ...itemVariant,
          ...itemCategory2,
          ...itemCategory3,
          ...itemCategory4,
        },
      ],
    },
  })
}
